import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { Helmet } from 'react-helmet';
const root = <>
    <Helmet data-id="element-1222">
      <title data-id="element-1223">
        Masterclass Gratuita: Vende Productos Digitales Con IA | Gabriel Beltrán
      </title>
      <meta name="description" content="Aprende a crear y vender productos digitales rentables usando IA. Masterclass gratuita con Gabriel Beltrán - 26 de noviembre, 7 PM. Recibe un regalo valorado en $297." data-id="element-1224" />
    </Helmet>
    <AppRouter data-id="element-1225" />
  </>;
render(root, document.getElementById('root'));